import { render, staticRenderFns } from "./social-security-data.vue?vue&type=template&id=0b172973"
import script from "./social-security-data.vue?vue&type=script&lang=ts"
export * from "./social-security-data.vue?vue&type=script&lang=ts"
import style0 from "./social-security-data.vue?vue&type=style&index=0&id=0b172973&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports